import { render, staticRenderFns } from "./PrintGLReportIS.vue?vue&type=template&id=68136981"
import script from "./PrintGLReportIS.vue?vue&type=script&lang=js"
export * from "./PrintGLReportIS.vue?vue&type=script&lang=js"
import style0 from "./Print.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports